import axios from 'axios'
import { ApiError, ErrorCode } from '@ivy-monorepo/shared'
import { LocalStorageKey } from '../helpers/constants'
import { API_URL } from '../config'

export const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Add a request interceptor to include auth token
apiClient.interceptors.request.use(
  config => {
    const authData = localStorage.getItem(LocalStorageKey.auth)
    if (authData) {
      const { token } = JSON.parse(authData)
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Add a response interceptor to handle errors consistently
apiClient.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response && error.response.data) {
      // Extract error details from response
      const { code, message, friendlyMessage } = error.response.data

      // Create a proper ApiError instance using the shared class
      const apiError = new ApiError(
        code || ErrorCode.UnknownError,
        message || 'An unexpected error occurred.',
        friendlyMessage || undefined
      )

      return Promise.reject(apiError)
    }
    return Promise.reject(error)
  }
)
